<template>
  <div >
    
     

    <ScatterChart 
      :chart-data="datacollection"
    ></ScatterChart>
  
  </div>
</template>

<script>
  /* eslint-disable */
  import ScatterChart from './ScatterChart'
  // import axios from 'axios'
  // npm i axios

  export default {
    components: {
      ScatterChart
    },
    data () {
      return {
        datacollection: null,
        PCV: [], //[0,1,2,3,4,5,6,7,8,9],
        BUN: [], // [9,8,7,6,5,4,3,2,1,0],
        CRETITNIE: [] , //[4,5,4,5,4,5,4,5,4,15],
        time: ['1/1/20','2/1/20','3/1/20','4/1/20','5/1/20','6/1/20','7/1/20','8/1/20','9/1/20','10/1/20']
      }
    },
     mounted () {
      this.PCV = this.getRandomIntAsJsonArray() 
      this.BUN = this.getRandomIntAsJsonArray()
      this.CRETITNIE =  this.getRandomIntAsJsonArray()

      this.fillData()

    },
    methods: {
      fillData () {
        this.datacollection = {
          labels: this.time,
          datasets: [
            {
              label: 'PCV',
              backgroundColor: 'rgba(0, 0, 255, 0.1)',
              borderColor: 'lightblue', 
              pointBackgroundColor: 'blue', 
              borderWidth: 1, 
              pointBorderColor: 'blue',
              // data: [1,2,3,2,1,3,4,6,7,8],
              data: this.PCV
            }, 
            {
              label: 'BUN',
              backgroundColor: 'red',
              borderColor: 'red', 
              pointBackgroundColor: 'red', 
              borderWidth: 1, 
              pointBorderColor: 'red',
              // data: [6,7,6,8,7,8,6,7,6,6]
              data:  this.BUN  
            },
            {
              label: 'CRETINENE',
              backgroundColor: 'orange',
              borderColor: 'orange', 
              pointBackgroundColor: 'orange', 
              borderWidth: 1, 
              pointBorderColor: 'orange',
              data:  this.CRETITNIE
            }
          ]
        }
      }
      ,
        getRandomInt () {
          return Math.floor(Math.random() * (50 - 5 + 1)) + 5
        }
      , getRandomIntAsJsonArray(){
          var a = []  
          for(var i=0;i<10;i++){
           var x_y = {x : null , y : null}
            x_y["x"] = this.getRandomInt()
            x_y["y"] = this.getRandomInt() 
            a.push(x_y)
          }
          return a
      }
       
    
      
      
    }
  }
</script>

<style>
  .small {
    width: 500px;
    height: 100px;
    margin: auto
  }
</style>